export const orderStatus = [
  'Todos',
  'Enviado',
  'Entregue',
  'Devolvido',
  'Cancelado',
  'Extraviado',
  'Processado'
]



// WEBPACK FOOTER //
// ./src/app/modules/OrdersRequestList/data.js